import axios from "axios";
// Create Axios Instance
const api = axios.create({
    //baseURL: "https://backend.vedic.online/api",
    //baseURL: "https://localhost:7054/api",
    baseURL: "https://api.shreebrains.com/api",
    //baseURL: "https://localhost:7001/api",
    //baseURL: "http://localhost:8085/api",
    //baseURL: "http://api.shreebrains.com/api",
    // headers: {
    //     "Content-Type": "application/json",
    // },
    timeout: 60000,
});

export const getApi = async (url) => {
    try {
        const response = await api.get(url);
        return response.data;
    } catch (error) {
        console.error("GET API Error:", error);
        throw error;
    }
};

export const getApiWithParam = async (url, config = {}) => {
    try {
        const response = await api.get(url, config);
        return response.data;
    } catch (error) {
        console.error("GET API Error:", error);
        throw error;
    }
};

// Common POST Method
export const postApi = async (url, data, config = {}) => {
    try {
        const response = await api.post(url, data, config);

        return {
            success: true,
            status: response.status,
            statusCode: response.status,
            data: response.data,
            message: response.data.message || "",
        };
    } catch (error) {
        console.error("POST API Error:", error);

        const response = error.response || {};

        return {
            success: false,
            status: response.status || 500,
            statusCode:
                response.data && response.data.statusCode
                    ? response.data.statusCode
                    : response.status || 500,
            data: response.data || null,
            message:
                (response.data &&
                    (response.data.message || response.data.description)) ||
                error.message,
        };
    }
};

export const putApi = async (url, data) => api.put(url, data);

export const patchApi = async (url, data) => api.patch(url, data);

export const deleteApi = async (url, data) => {
    try {
        const response = await api.delete(url, data);
        return response.data;
    } catch (error) {
        console.error("DELETE API Error:", error);
        throw error;
    }
};

export default api;